import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="py-12 px-4" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <FadeIn data-id="element-132">
          <div className="glass-card rounded-2xl p-6 md:p-10 text-center relative overflow-hidden" data-id="element-133">
            {/* Decorative stars */}
            <div className="flex justify-center gap-1.5 mb-5" data-id="element-134">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-135" />)}
            </div>

            <p className="text-lg md:text-xl text-warmWhite-100 leading-relaxed mb-5 font-medium" data-id="element-136">
              En solo 7 días, notarás que el "ruido mental" al acostarte
              disminuye. Tu cuerpo aprenderá a bajar su temperatura de forma
              automática y los despertares nocturnos serán cada vez más breves
              hasta desaparecer.
            </p>

            <div className="inline-block px-6 py-2 rounded-full bg-gold-500/10 border border-gold-500/20" data-id="element-137">
              <p className="text-gold-400 font-heading font-bold tracking-wide uppercase text-sm" data-id="element-138">
                No es magia, es cronobiología aplicada.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}